import React from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    BooleanField,
    BooleanInput,
    NumberInput,
    NumberField, ReferenceField, UrlField, ReferenceInput, required, SelectInput, ImageInput, ImageField, maxLength
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import Emoji from "../../components/Emoji";
import {ColorInput} from "react-admin-color-input";
import {GradientColorInputTags} from "../forum/forumConstant";

const SpecialistCommentFilter = (props) => (
  <Filter {...props}>
      <TextInput label="شناسه" source="objectId"/>
      <TextInput label="شناسه متخصص" source="specialistUserId"/>
      <TextInput label="شناسه کاربر" source="userId"/>
      <TextInput label="شناسه مکالمه" source="conversationId"/>
      <BooleanInput label="متخصص توصیه شده؟" source="recommendedSpecialist"/>
      <NumberInput label="امتیاز" source="rate"/>
      <TextInput label="متن" source="text"/>
  </Filter>
);

export const SpecialistCommentList = (props) => (
  <List {...props} filters={<SpecialistCommentFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر متخصص" source="specialistUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <BooleanField source="recommendedSpecialist"/>
        <NumberField source="rate"/>
        <TextField source="text"/>
        <BooleanField source="visible"/>
        <TextField source="conversationId"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const SpecialistCommentShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر متخصص" source="specialistUserId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <BooleanField source="recommendedSpecialist"/>
        <NumberField source="rate"/>
        <TextField source="text"/>
        <BooleanField source="visible"/>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);

export const SpecialistCommentEdit = (props) => (
    <EditView {...props}>
        <BooleanInput source="visible"/>
    </EditView>
);
